import SolarPlantList from './SolarPlantList';

export default SolarPlantList;
